import { FC } from 'react';

import { Nullable } from 'types';

import balanceAndBonusesHistoryChipsButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/balance_and_bonuses/balance_and_bonuses_history_chips_button_click';
import { CustomChip, HSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { BalanceHistoryFilterType } from 'store/models/balance';

const FILTER_TYPES = Object.values(BalanceHistoryFilterType);

export const HistoryChips: FC<{
    selectedFilterType: Nullable<BalanceHistoryFilterType>;
    onChipClick: (chipType: BalanceHistoryFilterType) => void;
}> = ({ selectedFilterType, onChipClick }) => {
    const trls = useTrls();

    return (
        <HSpacingContainer default={12}>
            {FILTER_TYPES.map((chipType) => (
                <CustomChip
                    key={chipType}
                    checked={chipType === selectedFilterType}
                    onClick={() => {
                        onChipClick(chipType);
                        balanceAndBonusesHistoryChipsButtonClick({ chipType });
                    }}
                >
                    {trls(`BalanceAndBonuses.History.filterType.${chipType}`)}
                </CustomChip>
            ))}
        </HSpacingContainer>
    );
};
